export default Object.freeze({
    DAY: 0,
    WEEK: 1,
    MONTH: 2
});